import { Injectable } from '@angular/core';
import { IPosition } from '../../models/position.model';
import { HttpClient } from '@angular/common/http';
import { ISibasiHTTPResponse } from 'src/app/common/model/sibasiHTTPResponse.model';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { IPagination } from 'src/app/common/model/util.model';

@Injectable({
  providedIn: 'root'
})
export class PositionService {
  constructor(private httpClient: HttpClient) {}

  getAllPositions(): Observable<ISibasiHTTPResponse<IPosition[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IPosition[]>>(
      `${environment.api_url}position`
    );
  }

  getAllPositionsPagination(
    paginationParams: IPagination<IPosition[]>
  ): Observable<ISibasiHTTPResponse<IPagination<IPosition[]>>> {
    return this.httpClient.post<ISibasiHTTPResponse<IPagination<IPosition[]>>>(
      `${environment.api_url}position/all/paginated`,
      paginationParams
    );
  }

  getPositionById(positionId: string): Observable<ISibasiHTTPResponse<IPosition>> {
    return this.httpClient.get<ISibasiHTTPResponse<IPosition>>(
      `${environment.api_url}position/${positionId}`
    );
  }

  deletePosition(positionId: string): Observable<ISibasiHTTPResponse<IPosition>> {
    return this.httpClient.delete<ISibasiHTTPResponse<IPosition>>(
      `${environment.api_url}position/${positionId}`
    );
  }

  createPosition(position: any): Observable<ISibasiHTTPResponse<IPosition>> {
    return this.httpClient.post<ISibasiHTTPResponse<IPosition>>(
      `${environment.api_url}position`,
      position
    );
  }

  updatePosition(position: any): Observable<ISibasiHTTPResponse<IPosition>> {
    return this.httpClient.post<ISibasiHTTPResponse<IPosition>>(
      `${environment.api_url}position/${position._id}`,
      position
    );
  }
}
